module.exports = __webpack_public_path__ + "static/5@2x-793ee6a6eef8026ff4b548e6bbc7b604.png";